import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'libHoursMinutesDuration',
})
export class HoursMinutesDurationPipe implements PipeTransform {
  transform(value: number | undefined | null): string {
    if (value == null || value < 0) {
      return '-';
    }

    const totalMinutes = Math.floor(value / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const paddedMinutes = String(minutes).padStart(2, '0');

    return `${hours} h ${paddedMinutes} m`;
  }
}
